<coop-offer-form
  [editMode]="true"
  [templateMode]="false"
  [formData]="formData"
></coop-offer-form>
